// removed by extract-text-webpack-plugin
module.exports = {"block":"_30B6qpusP8GBORWL57B7Jq","zebra":"_1terNCycY-L0z7QJztyF_c","yellow":"_1qlcID_4hImEYMOMjjkpbk","darkgray":"_20wJItjHxINfbLGbh01lpT","lightgray":"_1zd_MQw-B01KlcNP5-gSfc","white":"_2g8f23c2TZiL0DKzYE1DtZ","heading":"_2gCPxMmD74Y9ceVnOjj2k0"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Block/Block.module.scss
// module id = 821
// module chunks = 0